import { ref } from "vue";
import { parseUrl } from "./helper";

interface PageData {
  environment: string
  urlParams: string[] | null
  path: string;
  isPreview: boolean;
}

export const getPathForPageData = (): PageData | undefined => {
  //get the meta property og:Url from the head tag
  let previewUrl: string | undefined;
  let environment;
  let urlParams;
  let path: string | undefined;
  let isPreview = false;
  const metaUrl = document.head.querySelector("meta[property='og:url']");
  if (metaUrl instanceof HTMLMetaElement) {
    previewUrl = metaUrl.content.replace(/^https?:\/\/[^/]+/, "");
  }

  environment = parseUrl(window.location.href).environment;
  urlParams = parseUrl(window.location.href).params;
 
  if (!urlParams) return;
  path = urlParams.join("/");
  if (previewUrl && previewUrl.indexOf(path) < 0) {
    path = previewUrl;
    isPreview = true;
  }
  return { path, isPreview, environment, urlParams};
};